import React from 'react';

type RootElement = { rootElement?: HTMLElement };

export const RootElementContext = React.createContext<RootElement | undefined>(
    void 0,
);

type RootElementProviderProps = {
    children: React.ReactNode;
    rootElement?: HTMLElement;
};

export function RootElementProvider(props: RootElementProviderProps) {
    const { children, rootElement } = props;

    const value = React.useMemo<RootElement>(
        () => ({
            rootElement,
        }),
        [rootElement],
    );

    return (
        <RootElementContext.Provider value={value}>
            {children}
        </RootElementContext.Provider>
    );
}

export function useRootElement() {
    const context = React.useContext(RootElementContext);
    if (typeof context === 'undefined') {
        throw new Error(
            'useRootElement must be used within an RootElementProvider',
        );
    }
    return context;
}
